import React from "react";
import { VStack, Heading, Text, Box, Flex, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

type ErrorType = "unauthorized" | "generic";

type ErrorProps = {
  type?: ErrorType;
  title?: string | null;
  message?: string | null;
};

const defaultContent: Record<ErrorType, { title: string; message: string }> = {
  unauthorized: {
    title: "Not authorized",
    message:
      "You are not authorized to perform this action. Please contact an administrator for access.",
  },
  generic: {
    title: "Something went wrong",
    message: "An unexpected error occurred.",
  },
};

const Error: React.FC<ErrorProps> = ({ type = "generic", title, message }) => {
  const content = defaultContent[type];
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Flex minH="60vh" align="center" justify="center">
      <Box textAlign="center">
        <VStack spacing={6}>
          <Heading size="md">{title || content.title}</Heading>
          <Text color="gray.500">{message || content.message}</Text>
          <Button colorScheme="blue" onClick={() => navigate("/")}>
            {t("error.homeButton") || "Home"}
          </Button>
        </VStack>
      </Box>
    </Flex>
  );
};

export default Error;
